import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { Company } from '../../models/company.model';

@Component({
  selector: 'bwc-company-card',
  templateUrl: './company-card.component.html',
  styleUrls: ['./company-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CompanyCardComponent {
  @Input() company: Company;
  @Input() isFollowed = false;
  @Input() showNewBadge = false;
  @Output() followed = new EventEmitter<Company>();

  onFollow(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.followed.emit(this.company);
  }
}
